export default function () {
  const widgetName = 'microModalFeature';
  const widgetOpts = microModalFeatureOpts;


  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {

      const d = data.items[0];
      const title = d.Title;
      const description = d.Description;
      const url = d.URL;
      const img = d.ImageWithPath;

      let logoHeader = "logo.png"


      function initializePopupModal() {
        $('body').append(`
          <div class="micromodal-slide" id="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
              <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                <span class="modal-close-btn" data-micromodal-close>
                <div></div>
                <div></div>
                </span>
                  <header class="modal__header">
                    <img class="modal-logo" src="${FULLCLIENTTHEMEPATH}images/${logoHeader}">
                  </header>
                <div class="modal__content" id="modal-content">
                             <div class="modal__content-right">
                    <h2 class="modal__title" id="modal-title">${title}</h2>
                    <p>${description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `);

        MicroModal.init();
        MicroModal.show('modal');
      }

      if (navigator.cookieEnabled && $('#modal') && $('body').hasClass('homepage')) {
        if (Cookies.get('modalCookie')) {
          return false;


        } else {
          Cookies.set('modalCookie', 'modalCookie', { expires: 15 });
          initializePopupModal();
        }
      }
    },
    buyNowButton: {
      visible: false,
      text: ''
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [],
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'DOWNLOAD'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false,
    textOverImage: false
  });
}